<template>
  <v-snackbar 
    top
    :value="isOpen"
    @input="handleInput"
    v-bind='$attrs'>
    {{ message }}
    <template v-slot:action="actionProps">
      <slot name='action' v-bind="actionProps">
        <close-button
          v-bind="actionProps.attrs"
          @close="close"
        />
      </slot>
    </template>
  </v-snackbar>
</template>

<script>
import { defineComponent, computed, provide, ref } from 'vue'
import CloseButton from './CloseButton.vue'

export function setupNotifier(){
  const snackbarMessage = ref(null);

  provide('snackbarMessage', snackbarMessage);

  return {
    snackbarMessage
  }
}

export default defineComponent({
  components: { 
    CloseButton 
  },
  props: {
    message: {
      type: String
    }
  },
  setup(props, context) {
    const isOpen = computed(()=> props.message);

    const close = ()=>{
      context.emit('update:message', null);
    }

    const handleInput = (value)=>{
      if (!value){
        close()

      }
    }

    return {
      handleInput,
      isOpen,
      close
    }
  },
})
</script>
